import { CommonModule } from "@angular/common";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { CorpCardComponent, CorpInputComponent, CorpLoadingComponent } from "@corporate-tailwind/component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { OrderWizardService } from "../../../_service/order-wizard.service";
import { CorpTranslateService } from "@corporate-tailwind/translation";
import { CustomerDto, CustomerDtoForValidation } from "../../../../model/customer.model";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MsToTimePipe } from "src/app/shared/pipe/ms-to-time.pipe";
import { CorpModalComponent } from "@corporate-tailwind/modal";
import { Router } from "@angular/router";

@Component({
    selector: 'itsme-email-validation',
    imports: [CommonModule,ReactiveFormsModule, TranslateModule, CorpLoadingComponent, CorpInputComponent, CorpModalComponent, MsToTimePipe],
    templateUrl: './itsme-email-validation.component.html',
    animations: [ ]
})
export class ItsMeEmailValidationComponent implements OnInit, OnDestroy {
form: FormGroup | null = null;

    constructor(
        public _orderWizardService: OrderWizardService,
        private _translateService: TranslateService,
        private _router: Router,
        private _corpTranslateService: CorpTranslateService
    ) {
        this.form = this._orderWizardService.formGroup;
    }


    ngOnInit(): void {
// this._orderWizardService.orderWizard$()?.step03?.customerDto?.isAskMailConfirmed
    }

    ngOnDestroy(): void {

    }

    sendValidation() {
        let customer = new CustomerDto();
        customer = this._orderWizardService.orderWizard$()?.step03?.customerDto!;
        customer.languageCode = this._translateService.getCurrentLang();
        customer.email = this._orderWizardService.getValue(x=>x.step03?.customerDto)?.email; 
        
        this._orderWizardService.emailValidationSend(customer);

    }

    goHome(): void {
        this._router.navigate(['/']);
    }

}